import React from 'react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../ui/table';
import { ListOrdered } from 'lucide-react';
import ChartCard from './ChartCard';

const thermalBadge = (row) => {
  if (row.cooling_active) return 'Cooling';
  if (row.heating_active) return 'Heating';
  return '—';
};

/**
 * Charging Timeline Table: one row roughly every 10% SoC within the selected range, plus the
 * exact start/target (or capped completion) rows, each showing Voltage/Current/Power/Elapsed
 * Time/Pack Temp/thermal-system state at that point, plus which constraint was setting the
 * charge current there (Limiter -- charger power, battery C-rate, low-temperature limit, BMS
 * SoC taper, CV voltage limit, ...). backend/simulation/charging.py builds this row set
 * server-side.
 */
const ChargingTimelinePanel = ({ timeline }) => {
  if (!timeline || timeline.length === 0) return null;

  return (
    <ChartCard icon={ListOrdered} title="Charging Timeline" testId="charging-timeline-panel">
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>SoC (%)</TableHead>
              <TableHead className="text-right">Voltage (V)</TableHead>
              <TableHead className="text-right">Current (A)</TableHead>
              <TableHead className="text-right">Power (kW)</TableHead>
              <TableHead className="text-right">Elapsed Time</TableHead>
              <TableHead className="text-right">Pack Temp (°C)</TableHead>
              <TableHead className="text-center">Thermal</TableHead>
              <TableHead className="text-center">Phase</TableHead>
              <TableHead>Limited By</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {timeline.map((row) => (
              <TableRow key={row.soc_pct} data-testid={`timeline-row-${row.soc_pct}`}>
                <TableCell className="font-mono text-xs font-bold">{row.soc_pct.toFixed(1)}</TableCell>
                <TableCell className="text-right font-mono text-xs">{row.voltage_v.toFixed(1)}</TableCell>
                <TableCell className="text-right font-mono text-xs">{row.current_a.toFixed(1)}</TableCell>
                <TableCell className="text-right font-mono text-xs">{row.power_kw.toFixed(2)}</TableCell>
                <TableCell className="text-right font-mono text-xs">{row.elapsed_min.toFixed(1)} min</TableCell>
                <TableCell className="text-right font-mono text-xs">{row.pack_temp_c.toFixed(1)}</TableCell>
                <TableCell className="text-center font-mono text-[11px] uppercase">{thermalBadge(row)}</TableCell>
                <TableCell className="text-center font-mono text-[11px] uppercase">{row.phase}</TableCell>
                <TableCell className="font-mono text-[11px] whitespace-nowrap">{row.limiter}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </ChartCard>
  );
};

export default ChargingTimelinePanel;
